exports.default = {
  'download_success': '图片下载成功',
  'download_failed': '图片下载失败',
  'code_copy_success': '代码复制成功',
  'copy_failed': '复制失败',
  'chart_not_found': '未找到图表',
  'container_not_found': '容器未找到',
  'fullscreen_failed': '全屏显示失败',
  'image_copied_to_clipboard': '复制成功',
  'copy_image_failed_unsupported': '复制图片失败，您的浏览器可能不支持此功能',
  'copy_image_failed': '复制图片失败',
  // 工具栏相关
  'chart_tab': '图片',
  'code_tab': '代码',
  'download_image_tooltip': '下载图片',
  'copy_image_tooltip': '复制图片',
  'zoom_in_tooltip': '放大',
  'zoom_out_tooltip': '缩小',
  'fit_page_tooltip': '适应页面',
  'fullscreen_tooltip': '全屏查看',
  'copy_code_tooltip': '复制代码',
  // 状态信息
  'image_generating': '图片生成中',
  'image_generation_failed': '图片生成失败',
  'waiting_code_complete': '等待代码完整...',
  'switch_to_code_view': '请切换到代码视图查看原始代码'
}
